export default __webpack_public_path__ + "static/media/optimizely.2cf60cbd.svg";